module.exports = __webpack_public_path__ + "img/1.1bf01ac5.jpg";